module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-loadmore"
  }, [_c('p', {
    staticClass: "page-loadmore-desc"
  }, [_vm._v("在列表底部, 按住 - 上拉 - 释放可以获取更多数据")]), _vm._v(" "), _c('p', {
    staticClass: "page-loadmore-desc"
  }, [_vm._v("此例请使用手机查看")]), _vm._v(" "), _c('div', {
    ref: "wrapper",
    staticClass: "page-loadmore-wrapper",
    style: ({
      height: _vm.wrapperHeight + 'px'
    })
  }, [_c('mt-loadmore', {
    ref: "loadmore",
    attrs: {
      "bottom-method": _vm.loadBottom,
      "bottom-all-loaded": _vm.allLoaded
    },
    on: {
      "bottom-status-change": _vm.handleBottomChange
    }
  }, [_c('ul', {
    staticClass: "page-loadmore-list"
  }, _vm._l((_vm.list), function(item) {
    return _c('li', {
      staticClass: "page-loadmore-listitem"
    }, [_vm._v(_vm._s(item))])
  })), _vm._v(" "), _c('div', {
    staticClass: "mint-loadmore-bottom",
    attrs: {
      "slot": "bottom"
    },
    slot: "bottom"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.bottomStatus !== 'loading'),
      expression: "bottomStatus !== 'loading'"
    }],
    class: {
      'is-rotate': _vm.bottomStatus === 'drop'
    }
  }, [_vm._v("↑")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.bottomStatus === 'loading'),
      expression: "bottomStatus === 'loading'"
    }]
  }, [_c('mt-spinner', {
    attrs: {
      "type": "snake"
    }
  })], 1)])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58edfa40","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./example/pages/pull-up.vue
// module id = 591
// module chunks = 0